import Box from '@mui/material/Box';

type NumberBadgeProps = {
  value: number;
};

export const NumberBadge = ({ value }: NumberBadgeProps) => {
  return (
    <Box
      sx={{
        bgcolor: '#DE2A6C',
        color: 'error.contrastText',
        width: 20,
        height: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        fontSize: '0.75rem',
      }}
    >
      {value}
    </Box>
  );
};
